import React from "react";

interface WaterfallGridProps {
  children: React.ReactNode[];
  columns?: number;
  className?: string;
}

export default function WaterfallGrid({
  children,
  columns = 3,
  className = "",
}: WaterfallGridProps) {
  const getStaggerOffset = (index: number) => {
    const offsets = ["mt-0", "mt-4", "mt-8", "mt-2", "mt-6", "mt-10"];
    return offsets[index % offsets.length];
  };
  return (
    <div
      className={`w-full ${className}`}
      style={{
        columnCount: columns,
        columnGap: "3rem",
        columnFill: "balance",
      }}
    >
      {children.map((child, index) => (
        <div
          key={index}
          className={`mb-4 break-inside-avoid ${getStaggerOffset(index)}`}
          style={{ display: "inline-block", width: "100%" }}
        >
          {child}
        </div>
      ))}
    </div>
  );
}
